<app-file-upload-modal></app-file-upload-modal>
<app-force-upload-verification-modal></app-force-upload-verification-modal>

<div class="browse-table-header">
  <div class="browse-table-header__details">
    <i class="fa fa-envelope browse-table-header__details-icon" aria-hidden="true"></i>
    <span class="browse-table-header__details-text">{{ parentNode.label }} ({{ nodes?.length || 0 }})</span>
  </div>

  <div class="browse-table-header__control-panel">
    <lib-button
      *ngIf="canShowUploadButton()"
      class="browse-table-header__control-panel-button"
      (click)="onFileUpload()"
    >
      Upload <i class="fa fa-upload browse-table-header__control-panel-button-icon"></i>
    </lib-button>

    <div class="browse-table-header__control-panel-input-group">
      <lib-text-input
        class="browse-table-header__control-panel-input"
        [model]="searchValue"
        [placeholder]="'Search'"
        (modelChange)="onSearchValueChange($event)"
      >
      </lib-text-input>

      <lib-icon class="browse-table-header__control-panel-input-icon" [iconType]="iconType.Search"></lib-icon>
    </div>
  </div>
</div>

<div class="browse-table">
  <div class="browse-table__head">
    <div class="browse-table__head-row">
      <div class="browse-table__head-cell browse-table__select-col">
        <lib-checkbox-button
          [disabled]="isSelectAllDisplayedNodesCheckbox()"
          [isChecked]="allDisplayedNodesSelected"
          (click)="onSelectAllDisplayedNodesCheckboxClick()"
        >
        </lib-checkbox-button>
      </div>

      <div
        class="browse-table__head-cell browse-table__name-col browse-table__head-cell--sortable"
        sortable="name"
        (updateSorting)="updateSorting($event)"
      >
        File Name
      </div>
      <div
        class="browse-table__head-cell browse-table__type-col browse-table__head-cell--sortable"
        sortable="type"
        (updateSorting)="updateSorting($event)"
      >
        File Type
      </div>

      <div
        class="browse-table__head-cell browse-table__size-col browse-table__head-cell--sortable"
        sortable="size"
        (updateSorting)="updateSorting($event)"
      >
        File Size
      </div>

      <div
        class="browse-table__head-cell browse-table__timestamp-col browse-table__head-cell--sortable"
        sortable="last_modified_on"
        (updateSorting)="updateSorting($event)"
      >
        Last Modified
      </div>

      <div class="browse-table__head-cell browse-table__icons-col"></div>
    </div>
  </div>

  <div class="browse-table__body">
    <lib-scrollable-container>
      <div
        *ngFor="let node of displayedNodes; let odd = odd; trackBy: trackByNode"
        [ngClass]="odd ? 'browse-table__body-row--white' : 'browse-table__body-row--gray'"
        class="browse-table__body-row"
      >
        <div class="browse-table__body-cell browse-table__select-col">
          <lib-checkbox-button
            [isChecked]="node.selected"
            [disabled]="isFileCheckboxDisabled(node.name)"
            (click)="onFileCheckboxClick(node)"
          >
          </lib-checkbox-button>
        </div>

        <div class="browse-table__body-cell browse-table__name-col">
          <i
            class="fa {{ getDocIcon(node.name) }} fa-color--{{ getDocIconColor(node.name) }} browse-table__file-icon"
          ></i>
          <span class="browse-table__name-col-text" [innerHTML]="node.name | highlight : searchValue"> </span>
        </div>

        <div class="browse-table__body-cell browse-table__type-col">
          {{ node.type }}
        </div>

        <div class="browse-table__body-cell browse-table__size-col">
          {{ getFileSize(node.size) }}
        </div>

        <div class="browse-table__body-cell browse-table__timestamp-col">
          {{ node.last_modified_on | date : "MM/dd/yyyy h:mm a" }}
        </div>

        <div class="browse-table__body-cell browse-table__icons-col browse-table__body-controls-cell">
          <i
            class="fa fa-download browse-table__body-controls-cell-icon browse-table__body-controls-cell-icon-download"
            [attr.title]="'Download'"
            (click)="onDownloadFile(node)"
          >
          </i>

          <i
            class="fa fa-trash browse-table__body-controls-cell-icon browse-table__body-controls-cell-icon-delete"
            *ngIf="canShowDeleteButton()"
            [attr.title]="'Delete'"
            (click)="onDeleteFile(node)"
          >
          </i>

          <ng-template [ngIf]="isFileDownloading(node.name)">
            <div class="browse-table__body-controls-cell-icon-overlap">
              <lib-loader class="browse-table__body-controls-cell-icon-overlap-loader">Downloading ...</lib-loader>
            </div>
          </ng-template>
        </div>
      </div>
    </lib-scrollable-container>
  </div>
</div>

<div class="browse-table__pagination">
  <lib-button
    class="browse-table__pagination-download-button"
    [disabled]="isDownloadSelectedButtonDisabled()"
    [busy]="isDownloadSelectedButtonBusy()"
    (click)="onDownloadSelectedButtonClick()"
  >
    Download Selected
  </lib-button>

  <lib-pagination
    [page]="page"
    [totalPages]="totalPages"
    [size]="size"
    (pageChange)="onPageChange($event)"
    (sizeChange)="onSizeChange($event)"
  >
  </lib-pagination>
</div>
